import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from '../../core/shared/classes/api';
import { ApiService } from '../../core/services/api.service';
import { Onglet } from '../classes/onglet';

@Injectable()
export class Z16ProOngletService {

    constructor (
        private apiService: ApiService
    ) { }

    getOngletsByEntite(entiteId: string): Observable<ApiResponse> {
        return this.apiService.get(`z16pro/entites/${entiteId}/onglets`);
    }

    getOngletsByEntiteCode(entiteCode: string): Observable<ApiResponse> {
        return this.apiService.get(`z16pro/entites/${entiteCode}/onglets`);
    }

    saveOnglet(onglet: Onglet) {
        return this.apiService.post(`z16pro/champs-onglet`, onglet.toChampOngletJson());
    }

    deleteOnglet(ongletId: string) {
        return this.apiService.delete(`z16pro/onglets/${ongletId}`);
    }

    changeOrder(data: {onglet: any, newIndex: number}) {
        return this.apiService.post(`z16pro/onglets/reorder`, data);
    }

}
